import { Stack, Typography, Box } from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/elements/Button";
import { background, divider, text } from "@/theme/colors";
import { rounded } from "@/theme/variables";
import { AppRoutes } from "@/routes/config";
import { buildCategoryRoute } from "@/utils/url";

type VocabularyStudySectionProps = {
  categoryName?: string;
};

export const VocabularyStudySection: FC<VocabularyStudySectionProps> = ({ categoryName }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Stack
      sx={{
        bgcolor: background.white,
        border: `1px solid ${divider.middle}`,
        borderRadius: rounded.xs,
        overflow: "hidden",
      }}
    >
      <Box sx={{ bgcolor: background.secondary, px: 2, py: 1 }}>
        <Typography variant="body14Semi" color={text.secondary}>
          {t("vocabulary.wordStudy")}
        </Typography>
      </Box>

      <Stack gap={2.5} sx={{ p: 2 }}>
        <Stack gap={1}>
          <Typography variant="body14Semi" color={text.secondary}>
            {t("vocabulary.practiceDescription")}
          </Typography>
          <Button variant="outline" fullWidth onClick={() => navigate(buildCategoryRoute(AppRoutes.vocabularyPractice, categoryName))}>
            {t("vocabulary.practice")}
          </Button>
        </Stack>

        <Stack gap={1}>
          <Typography variant="body14Semi" color={text.secondary}>
            {t("vocabulary.quizDescription")}
          </Typography>
          <Button variant="outline" fullWidth onClick={() => navigate(buildCategoryRoute(AppRoutes.vocabularyQuiz, categoryName))}>
            {t("vocabulary.confirmTest")}
          </Button>
        </Stack>
      </Stack>
    </Stack>
  );
};
